export default __webpack_public_path__ + "static/media/UG2-connectivity.5c248c9c.jpg";